import React from 'react';
import clsx from 'clsx';
import { FormSize } from "../../../../view-model";
import { useFormCommonProps } from "../../../context/form-common";
import '@isyc-react/design/main';
export const InputText = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    value,
    error,
    size,
    disabled,
    placeholder,
    maxLength,
    readOnly,
    className = 'form-control',
    onChange,
    onFocus,
    onBlur,
    dataTestId,
    type = 'text'
  } = useFormCommonProps(props);
  return /*#__PURE__*/React.createElement("input", {
    ref: ref,
    className: clsx({
      'form-control-sm': size === FormSize.SM,
      'form-control-lg': size === FormSize.LG,
      'form-control-xl': size === FormSize.XL,
      'is-invalid': error,
      'form-control-plaintext': readOnly,
      [className]: !readOnly
    }),
    "data-test-id": dataTestId,
    onChange: e => {
      onChange && onChange(e.target.value, e);
    },
    onFocus: onFocus,
    onBlur: onBlur,
    value: value,
    readOnly: readOnly,
    disabled: disabled,
    type: type,
    placeholder: placeholder,
    maxLength: maxLength
  });
});